export class PaymentTermsFilter {
    public IncludeInactive?: boolean;
}

export default PaymentTermsFilter;